module.exports = __webpack_public_path__ + "static/img/yanyu.3bdcba7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/yanyu.png
// module id = 7h7X
// module chunks = 1